import React, { FC, useState } from 'react';
import filter from 'lodash/filter';
import map from 'lodash/map';
import styled from 'styled-components';

import useIsFeatureEnabled from 'src/presentation/hooks/useIsFeatureEnabled';
import useRouter from 'src/presentation/hooks/useRouter';
import { AdminCategoryLink } from './AdminCategoryLink';
import { MenuCategory } from '@ad-scripts/presentation/components/common/nav/menu_category';
import { StyledNavLink } from '@ad-scripts/presentation/components/common/nav/nav_link_styles';

interface CategoryProps {
  children?: any;
  childrenOrder?: any;
  className?: string;
  icon?: any;
  isCollapsible?: boolean;
  label: string;
}

const AdminMenuCategory: FC<CategoryProps> = ({
  children,
  className,
  label,
  icon,
  isCollapsible = false,
  childrenOrder = [],
}) => {
  const [isSelectedState, setSelectedState] = useState(!isCollapsible);
  const { location } = useRouter();
  const isFeatureEnabled = useIsFeatureEnabled();

  const onClick = () => {
    isCollapsible && setSelectedState(!isSelectedState);
  };

  const childrenArray = children && (React.Children.toArray(children) as JSX.Element[]);

  const visibleItems = filter(
    childrenArray,
    (child: any) =>
      (!child.props.roleFeature || isFeatureEnabled(child.props.roleFeature)) &&
      (!child.props.featureFlag || isFeatureEnabled(child.props.featureFlag))
  );

  if (!visibleItems.length) {
    // if no items then category should not be rendered
    return null;
  }

  const routes = children && childrenArray.map((child: any) => child.props.to);
  const currentPath = location.pathname;
  const isCategorySelected = routes && routes.some(route => currentPath.startsWith(route));
  const isCategoryOpen = isCategorySelected || isSelectedState;

  const orderedChildren: any = childrenOrder.length
    ? map(childrenOrder, c => filter(visibleItems, (c1: any) => c === c1.props.label)[0])
    : visibleItems;

  const navigateTo = orderedChildren.find(child => child)?.props.to;

  return (
    <StyledMenuCategory
      className={className}
      icon={icon}
      isOpen={isCategoryOpen}
      label={
        <AdminCategoryLink to={navigateTo} onClick={onClick}>
          {label}
        </AdminCategoryLink>
      }
    >
      {orderedChildren}
    </StyledMenuCategory>
  );
};

const StyledMenuCategory = styled(MenuCategory)`
  ${StyledNavLink} {
    padding-left: ${p => p.theme.spacing.insetXXLarge};
  }
`;

export { AdminMenuCategory };
